import { gql } from '@apollo/client';

export const submitWhatsAppTemplateMutation = gql`
  mutation SubmitWhatsAppTemplate(
    $name: String!
    $language: String!
    $category: WhatsAppTemplateCategoryDefinition!
    $template: StructureDefinitionInput!
    $senderId: String!
    $whatsAppContentId: Long!
  ) {
    submitTemplate(
      name: $name
      language: $language
      category: $category
      template: $template
      senderId: $senderId
      whatsAppContentId: $whatsAppContentId
    ) {
      ... on WhatsAppTemplateSubmissionError {
        message
      }
      ... on WhatsAppTemplateSubmissionResponse {
        name
        language
        status
      }
    }
  }
`;
